import React, { useState } from "react";
import { Button, Popover } from "@material-ui/core";
import { useTranslation } from "react-i18next";

// TODO: this can be replaced with CysButtonPopover
export const ShowPerilsWithErrors = ({ errorsText }) => {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button variant="outlined" color="secondary" size="small" onClick={handleClick}>
        {t("table.inconsistentParcels")}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div>
          <p>{errorsText}</p>
        </div>
      </Popover>
    </>
  );
};
